import { useContext, useEffect, useState } from 'react';

import Honeybadger from '@honeybadger-io/js';

import { ToastContext } from '../../../../shared/context/Toast';
import { deserializer } from '../../../../shared/utils/deserializer';
import { fetchConversation as apiFetchConversation } from '../services/conversationService';

const useList = (taskId) => {
  const { showError } = useContext(ToastContext);

  const [isLoading, setIsLoading] = useState(true);
  const [messages, setMessages] = useState([]);

  const fetchMessages = async () => {
    setIsLoading(true);

    try {
      const response = await apiFetchConversation(taskId);
      const conversation = await deserializer.deserialize(response);

      setMessages(conversation.messages);
    } catch (error) {
      showError(error.message);
      Honeybadger.notify(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchMessages();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { fetchMessages, isLoading, messages };
};

export default useList;
